import React, { useContext, useState } from 'react';

//Component
import PaymentModel from"../PaymentModel/Payment.component";

//Context
import { MovieContext } from '../../Context/movie.context';
import {FaHeart} from "react-icons/fa";
import { BiChevronRight } from 'react-icons/bi';
const MovieInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [price, setPrice] = useState(0);
    const { movie } = useContext(MovieContext);
   
    //optional chaining
    const genres = movie.genres && movie.genres.map(({name}) => name).join(", ");
 
    const rentMovies = () => {
        setIsOpen(true);
        setPrice(149);
    };

    const buyMovies = () => {
        setIsOpen(true);
        setPrice(599);
    };


    return (
        <>
          <PaymentModel setIsOpen={setIsOpen} isOpen={isOpen} price={price} />
          <div className="flex flex-col gap-3 lg:gap-8">
              <div className="flex flex-col-reverse gap-3 lg:gap-5 lg:flex-col">
                <h1 className="text-white lg:text-5xl font-bold hidden lg:block">
                    {movie.original_title}
                </h1>

<div className="flex space-x-3">
<div className="flex space-x-3">
<FaHeart className=" mt-1.5 text-2xl hover:animate-pulse hover:text-red-600 text-red-700 hover:cursor-pointer"/>
<h1 className="text-white text-3xl font-semibold">81.51%</h1>
</div>


<div className="flex mt-2 text-white">
<h1>2.701k ratings </h1>
<BiChevronRight className="hover:cursor-pointer mt-1"/>
</div>
</div>
{/* 

<div className="flex w-2/4 h-20 lg:block bg-bGCol-700  justify-between rounded-lg">
    <div className="flex justify-between pt-2 px-2">
    <div >
        <h1 className="text-white text-xl">Add your ratings & review</h1>
        <h1 className="text-gray-400 text-lg">Your ratings matter</h1>
    </div>
    <div className="flex px-2 pt-1">
        <button className="mt-2 bg-white font-semibold rounded-sm w-24 h-8 text-black hover:cursor-pointer">Rate Now</button>
    </div>
    </div>
</div> */}


   <div className=" font-base text-white text-xl flex flex-col gap-2 ">
                    <div className=" w-96 flex bg-slate-200">
                    <h4 className="text-black font-semibold px-1 hover:underline cursor-pointer">2D,</h4>
                    <h4 className="text-black font-semibold px-1 hover:underline cursor-pointer">SCREENX, </h4>
                    <h4 className="text-black font-semibold px-1 hover:underline cursor-pointer">MX4D,</h4>
                    <h4 className="text-black font-semibold px-1 hover:underline cursor-pointer">IMAX3D,</h4>
                    <h4 className="text-black font-semibold px-1 hover:underline cursor-pointer">4DX ICE</h4>
                     </div>

                    <h4 >{(movie.runtime / 60).toFixed(2)} h &bull; {genres} &bull; 13+</h4>
                </div>
                <div className="flex items-center gap-3 md:px-4 md:w-screen lg:w-full">
                    <button onClick={buyMovies} className="bg-red-500 hover:bg-red-700 w-48 py-2 text-white font-semibold rounded-lg
inline-block  bg-primary px-6 pb-2 pt-2.5 text-lg leading-normal shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]
                    
                    ">
                        Book Tickets
                    </button>
                </div>
              </div>
          </div>
        </>
    )
}

export default MovieInfo;